import React from 'react'

import GooglePlacePin, {
  GoogleMarkerType,
  GoogleMarkerTypes,
} from './GooglePlacePin'
import TeardropPin from './TeardropPin'
import { ATTRACTION_TYPE, ACCOMMODATION_TYPE } from '../../MapSearch'

import LineBedIcon from 'components/Luxkit/Icons/line/LineBedIcon'
import LineUniversityIcon from 'components/Luxkit/Icons/line/LineUniversityIcon'

type SearchCategoryTypes = typeof ACCOMMODATION_TYPE | typeof ATTRACTION_TYPE

const categoryPinTypes: Record<
  Exclude<SearchCategoryTypes, typeof ACCOMMODATION_TYPE>,
  GoogleMarkerType
> = {
  attraction: GoogleMarkerTypes.outdoor,
}

interface Props
  extends Omit<
    React.ComponentProps<typeof GooglePlacePin>,
    'type' | 'children'
  > {
  category: SearchCategoryTypes
  saved?: boolean
}

function SearchPin({ category, saved, ...props }: Props) {
  // for now we only have two categories and the search for hotel pin is requested to be the same as saved hotel pins
  // as a placeholder until we do a bulk update to trip-planner pins...
  if (category === ACCOMMODATION_TYPE) {
    return (
      <TeardropPin isActive={saved}>
        <LineBedIcon colour="neutral-eight" />
      </TeardropPin>
    )
  }

  return (
    <GooglePlacePin
      type={categoryPinTypes[category]}
      size={saved ? 'large' : 'small'}
      {...props}
    >
      <LineUniversityIcon colour="neutral-eight" />
    </GooglePlacePin>
  )
}

export default SearchPin
